import {ScnroModel} from "app/model/rp/ScnroModel";
import React, {useEffect, useState} from "react";
import {ResponseResultCode} from "app/model/response-api";
import {RdmpCondService} from "app/services/rp/RdmpCondService";
import {SmcnCertService} from "app/services/rp/SmcnCertService";
import moment from "moment";
import {roundWithComma} from "app/utils/stringUtil";
import {CountUpUtil} from "app/utils/countUpUtil";
import CountUp from "react-countup";
import DashboardLoading from "./DashboardLoading";
import DashboardNoData from "./DashboardNoData";
import DashboardCard from "./DashboardCard";
import {DashboardModuleProps} from "app/model/db/dashboardModuleProps";

export default function ReAchievementRate(props: Readonly<DashboardModuleProps>) {
  const currentYear = moment().format('YYYY');
  const [qntInfo, setQntInfo] = useState<any>();
  const [latestScnro, setLatestScnro] = useState<ScnroModel>();
  const [sumSmcnCert, setSumSmcnCert] = useState<any>({'1': 0, '2': 0, '3': 0, '4': 0, '5': 0});
  const [sumREC, setSumREC] = useState<any>({2: 0});
  const [isCompleteFetchData, setIsCompleteFetchData] = useState<boolean>(false);
  const [currentReRt, setCurrentReRt] = useState<number>(0);
  const [currentGrprTppaReRt, setCurrentGrprTppaReRt] = useState<number>(0);
  const [currentEtcReRt, setCurrentEtcReRt] = useState<number>(0);
  const [isLoading, setIsLoading] = useState<any>(true);
  const [existsQntInfo, setExistsQntInfo] = useState<boolean>(false);
  const [existsLastScnro, setExistsLastScnro] = useState<boolean>(false);

  useEffect(() => {
    initData();
  }, []);

  function initData() {
    getQntInfo()
    .then(() => getLatestScnro())
    .then(() => getAllSumSmcnCert())
    .then(() => setIsCompleteFetchData(true))
    .finally(() => {
      setIsLoading(false);
    });
  }

  async function getQntInfo() {
    const response = await RdmpCondService.getInstance().getQntDetail();
    if (response && response.resultCode === ResponseResultCode.Y) {
      setQntInfo(response.data);
      setExistsQntInfo(response.data !== undefined && response.data !== null);
    }
  }

  async function getLatestScnro() {
    const response = await RdmpCondService.getInstance().getRegistScnro();
    if (response && ResponseResultCode.Y === response.resultCode) {
      setExistsLastScnro(response.data?.scnroId !== null && response.data?.scnroId !== undefined && response.data?.scnroId !== '');
      setLatestScnro(response.data);
    }
  }

  async function getAllSumSmcnCert() {
    const response = await SmcnCertService.getInstance().getSumEach(currentYear);
    if (response && ResponseResultCode.Y === response.resultCode) {
      setSumSmcnCert(response.data);
      setSumREC(response.data);
    }
  }

  useEffect(() => {
    if (isCompleteFetchData) {
      /* !!소수점은 화면에 보여주는 컴포넌트에서 처리 */
      const currentGrprTppaReRt = latestScnro?.emksSimlCgCd && qntInfo?.totalQntForRe
          // ? Math.floor(checkRdmpCodeByList([3, 5]) / qntInfo.totalQntForRe) * 100
          ? checkRdmpCodeByList([3, 5]) / qntInfo.totalQntForRe * 100
          : 0;

      const currentEtcReRt = latestScnro?.emksSimlCgCd && qntInfo?.totalQntForRe
          // ? Math.floor(checkRdmpCodeByList([1, 4]) / qntInfo.totalQntForRe) * 100
          ? checkRdmpCodeByList([1, 4]) / qntInfo.totalQntForRe * 100
          : 0;

      const currentReRt = currentGrprTppaReRt + currentEtcReRt;

      setCurrentReRt(currentReRt);
      setCurrentGrprTppaReRt(currentGrprTppaReRt);
      setCurrentEtcReRt(currentEtcReRt);
    }
  }, [isCompleteFetchData]);

  function checkRdmpCodeByList(inputNumb: number[]) {
    let sum = 0;

    if (latestScnro?.scnroInfoList) {
      if (latestScnro.scnroInfoList.some(item => item.emksFuflMeansCd === 1)) {
        if (inputNumb.includes(1)) {
          sum += sumSmcnCert['1'] ?? 0;
        }
      }
      if (latestScnro.scnroInfoList.some(item => item.emksFuflMeansCd === 2)) {
        if (inputNumb.includes(2)) {
          sum += sumREC['2'] ?? 0;
        }
      }
      if (latestScnro.scnroInfoList.some(item => item.emksFuflMeansCd === 3)) {
        if (inputNumb.includes(3)) {
          sum += sumSmcnCert['3'] ?? 0;
        }
      }
      if (latestScnro.scnroInfoList.some(item => item.emksFuflMeansCd === 6)) {
        if (inputNumb.includes(4)) {
          sum += sumSmcnCert['4'] ?? 0;
        }
        if (inputNumb.includes(5)) {
          sum += sumSmcnCert['5'] ?? 0;
        }
      }
    }
    return sum;
  }

  return (
      <DashboardCard
          title="RE 달성율"
          isConfigMode={props.isConfigMode ?? false}
          moreButtonVisible={true}
          moreButtonUrl="/rp/rdmp"
          dashboardConfig={props.dashboardConfig}
      >
        <DashboardLoading isLoading={isLoading}/>
        {(isCompleteFetchData && existsQntInfo && existsLastScnro) ? (
            <div className="space-around">
              <div className="cylinder-graph-wrap">
                <div className="cylinder-tit">
                  <span>현재 RE</span>
                  <strong>
                    <em>
                      <CountUp
                          end={roundWithComma(currentReRt, 2)}
                          decimals={CountUpUtil.getDecimal(roundWithComma(currentReRt, 2))}
                          duration={0.5}
                      />
                    </em>%
                  </strong>
                </div>
                <div className="cylinder-graph">
                  <div className="cylinder-wrap">
                    <div className="cylinder">
                      <div className="cylinder-top"></div>
                    </div>
                    <div className="water" style={{height: `${currentReRt}%`}}></div>
                  </div>
                  <div className="cylinder-bottom"></div>
                </div>
              </div>
              <div className="h-g-wrap">
                <div className="horizontal-graph-box">
                  <p className="tit">한전 에너지마켓플레이스(녹색 프리미엄, 제3자 PPA)</p>
                  <div className="graph-list-type5">
                    <div className="graph-list-gauge">
                      <div className="txt">
                        <span>현재 RE</span>
                        <strong>
                          <CountUp
                              end={roundWithComma(currentGrprTppaReRt, 2)}
                              decimals={CountUpUtil.getDecimal(roundWithComma(currentGrprTppaReRt, 2))}
                              duration={0.5}
                          />
                        </strong>
                        <em>%</em>
                      </div>
                      <div className="graph-count-vertical count-vertical">
                        <em style={{width: `${currentGrprTppaReRt}%`}}></em>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="horizontal-graph-box">
                  <p className="tit">e.CLOUD(REC, 직접PPA, 자가발전)</p>
                  <div className="graph-list-type5">
                    <div className="graph-list-gauge">
                      <div className="txt">
                        <span>현재 RE</span>
                        <strong>
                          <CountUp
                              end={roundWithComma(currentEtcReRt, 2)}
                              decimals={CountUpUtil.getDecimal(roundWithComma(currentEtcReRt, 2))}
                              duration={0.5}
                          />
                        </strong>
                        <em>%</em>
                      </div>
                      <div className="graph-count-vertical count-vertical">
                        <em style={{width: `${currentEtcReRt}%`}}></em>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        ) : (
            <>
              {isCompleteFetchData && (
                  <>
                    {!existsQntInfo ? (
                        <DashboardNoData message="전력 사용량 데이터가 존재하지 않습니다"/>
                    ) : (
                        <DashboardNoData
                            message="등록된 RE100 포트폴리오가 없습니다."
                            link={{text: '포트폴리오 등록하기', to: '/rp/portfolio'}}
                            className="ex-data1"
                        />
                    )}
                  </>
              )}
            </>
        )}
      </DashboardCard>
  )
}